import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { TABS } from 'src/app/dummy/tab';
import { AddSentenceCompletionComponent } from '../add-sentence-completion/add-sentence-completion.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { Location } from '@angular/common';
import { AddSentenceCompletionBlankComponent } from '../add-sentence-completion-blank/add-sentence-completion-blank.component';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { pushObjArray, ConvertService, removeObjArray } from 'src/app/services/convert.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT, SKILL_OBJECT } from 'src/app/dummy/status';
import { IActivity } from 'src/app/interfaces/resource';
import { DataService } from 'src/app/services/data.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';

@Component({
  selector: 'app-sentence-completion',
  templateUrl: './sentence-completion.component.html',
  styleUrls: ['./sentence-completion.component.scss']
})
export class SentenceCompletionComponent implements OnInit {
  tabs = TABS.sentence_completion;
  TITLE = "Modules"
  SUB_TITLE = "Activity Types"
  ITEM: any;
  ITEM_KEY: any;
  QUESTION_LIST: any[];
  MODULE_KEY: any;
  MODULE: any;
  form: FormGroup;
  reading: AbstractControl;
  instruction: AbstractControl;
  defaultInstruction: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  SKILL = 'reading';
  SKILL_NAME = 'Reading';
  ACTIVITY_TYPE = 'sentence_completion'
  ACTIVITY_LIST: any[] = [];
  ACTIVITY_TYPE_LIST: any[];
  ACTIVITY_TYPE_OBJECT: any = {};

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: ActivityStore
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
  ) { }


  goBack() {
    this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  }

  async ngOnInit() {
    this.form = this.fb.group({
      reading: [null, Validators.required],
      instruction: [null],
      defaultInstruction: [true],
    })
    await this.auth.fetchUser()
    this.route.params.subscribe(async params => {
      const { id, MODULE_KEY } = params;
      this.ITEM_KEY = id;
      this.MODULE_KEY = MODULE_KEY
      this.tabs = TABS.sentence_completion.filter(m => m.key === this.SKILL)
        .map(m => ({ path: `${m.path}/${MODULE_KEY}/${m.key === SKILL_OBJECT.READING.key ? id : 'draft'}`, label: m.label, key: m.key }))

      this.ACTIVITY_TYPE_LIST = await this.store.fetchActivityType()
      this.ACTIVITY_TYPE_OBJECT = this.ACTIVITY_TYPE_LIST.filter(m => m.key === this.ACTIVITY_TYPE)[0];
      this.MODULE = await this.store.fetchModule(this.MODULE_KEY)
      if (!this.MODULE) {
        this.router.navigate(['/404']);
        return;
      }
      if (id !== 'draft') {
        this.store.fetchActivity(id, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.QUESTION_LIST = [];
            this.goBack()
            return;
          }
          const { name, questions, instruction, defaultInstruction } = doc;
          this.form.patchValue({ reading: name, instruction, defaultInstruction })
          this.QUESTION_LIST = questions;
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.form.patchValue({ reading: null, instruction: null, defaultInstruction: true })
      }
    })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    const { fetchActivityRef } = this.store;
    fetchActivityRef && fetchActivityRef.unsubscribe();
    const { fetchActivityByModuleRef } = this.resource;
    fetchActivityByModuleRef && fetchActivityByModuleRef.unsubscribe();
  }


  onSave(f: any, isBack: boolean) {
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { reading, instruction, defaultInstruction } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IActivity = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        hasSubActivity: true,
        //fields
        name: reading || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        questions: this.ITEM ? this.ITEM.questions : [],
        skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
        skillRef: this.ds.skillRef().doc(this.SKILL).ref,
        skillName: this.SKILL_NAME,
        activityTypeKey: this.ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
        activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
        moduleKey: this.MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
      }
      this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
        if (success) {
          this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
          this.processClose = false;
          this.processNew = false;
          if (isBack) {
            this.location.back()
          }
          else {
            this.router.navigate([`/modules/activity-type/sentence_completion/${this.SKILL}/${this.MODULE_KEY}/${activity.key}`])
          }
          this.form.enable();
        }
      })
    }
  }

  edit(question) {
    let dialogRef = this.dialog.open(AddSentenceCompletionComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        QUESTION: question,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  delete(question) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Question' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { reading, instruction, defaultInstruction } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const { questions } = this.ITEM;
        const QUESTION_DATA = removeObjArray(questions, question.key)
        const registerStatus = STATUS_OBJECT.submitted;
        const activity: IActivity = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          hasSubActivity: true,
          //fields
          name: reading || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          questions: QUESTION_DATA,
          skillKey: this.ITEM.skillKey,
          skillRef: this.ITEM.skillRef,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ITEM.activityTypeKey,
          activityTypeRef: this.ITEM.activityTypeRef,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.ITEM.moduleKey,
          moduleRef: this.ITEM.moduleRef,
        }
        this.store.update(activity, (success, res) => {
          this.snackBar.open("Question has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }

  resetQuiz(question) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'reset', name: question.name, title: 'Reset Quiz' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { reading, instruction, defaultInstruction } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const { questions } = this.ITEM;
        const QUESTION_ITEM = { key: question.key, name: question.name, block: [] }
        const QUESTION_DATA = pushObjArray(questions, QUESTION_ITEM)
        const registerStatus = STATUS_OBJECT.submitted;
        const activity: IActivity = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          hasSubActivity: true,
          //fields
          name: reading || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          questions: QUESTION_DATA,
          skillKey: this.ITEM.skillKey,
          skillRef: this.ITEM.skillRef,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ITEM.activityTypeKey,
          activityTypeRef: this.ITEM.activityTypeRef,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.ITEM.moduleKey,
          moduleRef: this.ITEM.moduleRef,
        }
        this.store.update(activity, (success, res) => {
          this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    });
  }

  createQuiz(item) {
    let dialogRef = this.dialog.open(AddSentenceCompletionBlankComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        QUESTION: item,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '35vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  addNewLine(question?:any) {
    this.store.options = question ? question.block : [];
    let dialogRef = this.dialog.open(AddSentenceCompletionComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        QUESTION: question ||null,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,

      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
